import * as jsxRuntime from "D:\\workspace\\fj-packages\\apps\\fj-subscribe\\node_modules\\react\\jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment